export interface Radius {
  button: number
  popper: number
  modal: number
  input: number
  paper: number
  tag: number
}

export const radius: Radius = {
  button: 4,
  popper: 2,
  modal: 4,
  input: 2,
  paper: 4,
  tag: 12,
}
